import { EnderecoModel } from '@shared/models/backend'

export const enderecoReferenceModel: EnderecoModel = {
  id: null,
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  bairro: '',
  municipio: null,
  uf: null,
  semCEP: false,
  semNumero: false,
}
